import React, { useState, useEffect } from 'react';
import {
  Card, Row, Col, Layout, Table, Input, Dropdown, Menu, message, Modal, Button
} from 'antd';
import {
  PlusOutlined, InfoCircleOutlined, MoreOutlined, DeleteOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { urlAssets } from '../../config/global';

import ListAppsAction from './actions/action';

function ListApps() {
  const { Content } = Layout;
  const { Column } = Table;
  const { Search } = Input;
  const [keyword, setKeyword] = useState('');
  const [apps, setApps] = useState([]);

  const getApps = () => {
    ListAppsAction({type: 'apps', keyword: keyword}, sessionStorage.getItem('token')).then((res) => {
      setApps(res)
    });
  }

  const handleSearch = (value) => {
    setKeyword(value);
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: 'Are you sure?',
      content: (
        <div>
          <p>Deleted data cannot be restored</p>
        </div>
      ),
      okText: 'Delete',
      showCancel: true,
      onCancel: () => {},
      cancelText: 'Cancel',
      // confirmLoading: loading,
      onOk: async () => {
        ListAppsAction({type: 'apps/delete'}, sessionStorage.getItem('token'), null, id).then((res) => {
          message.info(res.message);
          getApps();
        });
      },
    });
  };

  useEffect(() => {
    getApps()
  }, [keyword]);

  return (
    <>
      <Content className="content m-0">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Row style={{marginBottom: '15px'}}>
                <Col span={4}>
                  <Link type="primary" to="apps/create">
                    <Button type="primary" className="btn-success">
                      <PlusOutlined />
                      Add Application
                    </Button>
                  </Link>
                </Col>
                <Col span={20}>
                  <Search placeholder="Search" onSearch={(value) => handleSearch(value)} style={{ width: 200, float: 'right' }} />
                </Col>
              </Row>
              <Table 
                dataSource={apps} 
                size="middle" 
                pagination={{ pageSize: 10, total: apps.length }}
              >
                <Column title="No" key="_id" render={(value, item, index) => index + 1} />
                <Column title="Application Name" dataIndex="application_name" key="application_name" />
                <Column title="Link Path" dataIndex="link_path" key="link_path" />
                <Column title="Logo" dataIndex="logo" key="logo" render={logo => (
                  <img src={`${urlAssets}list_apps/${logo}`} alt={logo} height="120" />
                )} />
                <Column title="" dataIndex="_id" key="_id" render={
                  _id => (
                    <Dropdown
                      className="pointer"
                      overlay={(
                        <Menu>
                          <Menu.Item key="0">
                            <Link to={`/apps/update/${_id}`}>
                              <InfoCircleOutlined />
                              {' '}
                              Edit
                            </Link>
                          </Menu.Item>
                          <Menu.Item key="0">
                          <span onClick={() => handleDelete(_id)}>
                            <DeleteOutlined />
                            Delete
                          </span>
                          </Menu.Item>
                        </Menu>
                      )}
                      trigger={['click']}
                    >
                      <span className="pointer" onClick={(e) => e.preventDefault()}>
                        <MoreOutlined />
                      </span>
                    </Dropdown>
                  )
                }>
                </Column>
              </Table>
            </Card>
          </Col>
        </Row>
      </Content>
    </>
  );
}

export default ListApps;
